import React from 'react';
import { UserIcon, CameraIcon } from 'lucide-react';
export const AccountSettings = () => {
  return <div data-id="element-1250">
      <div className="mb-6" data-id="element-1251">
        <h2 className="text-lg font-semibold" data-id="element-1252">Account Settings</h2>
        <p className="text-gray-600" data-id="element-1253">
          Manage your personal information and account preferences
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1254">
        <div className="lg:col-span-2" data-id="element-1255">
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1256">
            <h3 className="text-lg font-medium mb-4" data-id="element-1257">Personal Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1258">
              <div data-id="element-1259">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1260">
                  First Name
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="John" data-id="element-1261" />
              </div>
              <div data-id="element-1262">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1263">
                  Last Name
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="Doe" data-id="element-1264" />
              </div>
              <div data-id="element-1265">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1266">
                  Email Address
                </label>
                <input type="email" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="john.doe@example.com" data-id="element-1267" />
              </div>
              <div data-id="element-1268">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1269">
                  Phone Number
                </label>
                <input type="tel" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="+1 (555) 123-4567" data-id="element-1270" />
              </div>
              <div className="md:col-span-2" data-id="element-1271">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1272">
                  Job Title
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="HR Manager" data-id="element-1273" />
              </div>
            </div>
            <h3 className="text-lg font-medium mb-4" data-id="element-1274">Company Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1275">
              <div data-id="element-1276">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1277">
                  Company Name
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="Acme Corporation" data-id="element-1278" />
              </div>
              <div data-id="element-1279">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1280">
                  Industry
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2" data-id="element-1281">
                  <option data-id="element-1282">Technology</option>
                  <option data-id="element-1283">Healthcare</option>
                  <option data-id="element-1284">Finance</option>
                  <option data-id="element-1285">Manufacturing</option>
                  <option data-id="element-1286">Retail</option>
                  <option data-id="element-1287">Education</option>
                  <option data-id="element-1288">Other</option>
                </select>
              </div>
              <div className="md:col-span-2" data-id="element-1289">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1290">
                  Company Website
                </label>
                <input type="url" className="w-full border border-gray-300 rounded-md px-3 py-2" defaultValue="https://www.acmecorp.com" data-id="element-1291" />
              </div>
            </div>
            <div className="mt-6 flex justify-end" data-id="element-1292">
              <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-1293">
                Save Changes
              </button>
            </div>
          </div>
        </div>
        <div data-id="element-1294">
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1295">
            <h3 className="text-lg font-medium mb-4" data-id="element-1296">Profile Picture</h3>
            <div className="flex flex-col items-center" data-id="element-1297">
              <div className="relative mb-4" data-id="element-1298">
                <div className="h-24 w-24 rounded-full bg-indigo-600 flex items-center justify-center text-white text-2xl" data-id="element-1299">
                  JD
                </div>
                <button className="absolute bottom-0 right-0 bg-white rounded-full p-1 border border-gray-300" data-id="element-1300">
                  <CameraIcon size={16} className="text-gray-600" data-id="element-1301" />
                </button>
              </div>
              <button className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-1302">
                Upload New Picture
              </button>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1303">
                JPG, GIF or PNG. Max size 2MB.
              </p>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-1304">
              <h3 className="text-lg font-medium mb-4" data-id="element-1305">Account Preferences</h3>
              <div className="space-y-4" data-id="element-1306">
                <div className="flex items-center justify-between" data-id="element-1307">
                  <div data-id="element-1308">
                    <p className="font-medium" data-id="element-1309">Language</p>
                    <p className="text-sm text-gray-500" data-id="element-1310">
                      Select your preferred language
                    </p>
                  </div>
                  <select className="border border-gray-300 rounded-md px-3 py-2" data-id="element-1311">
                    <option data-id="element-1312">English (US)</option>
                    <option data-id="element-1313">Spanish</option>
                    <option data-id="element-1314">French</option>
                    <option data-id="element-1315">German</option>
                  </select>
                </div>
                <div className="flex items-center justify-between" data-id="element-1316">
                  <div data-id="element-1317">
                    <p className="font-medium" data-id="element-1318">Time Zone</p>
                    <p className="text-sm text-gray-500" data-id="element-1319">
                      Set your local time zone
                    </p>
                  </div>
                  <select className="border border-gray-300 rounded-md px-3 py-2" data-id="element-1320">
                    <option data-id="element-1321">Pacific Time (PT)</option>
                    <option data-id="element-1322">Mountain Time (MT)</option>
                    <option data-id="element-1323">Central Time (CT)</option>
                    <option data-id="element-1324">Eastern Time (ET)</option>
                    <option data-id="element-1325">UTC</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};